// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentSingleOptionContainer_ZlyfD {
  display: flex;
  gap: 22px;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
}
.paymentSingleOptionContainerDisabled_mO2aG{
  opacity: 0.6;
}

.paymentSingleOptionIcons_W6GNG {
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
}

.iconWrapper_pWSXW {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 28px;
  background: #fdfdfc;
  border-radius: 3px;
  border: 1px solid #e2e2e2;
}

.paymentSingleOptionText_cBNet {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  div {
    color: var(--black-color);
    font-size: 15px;
    font-weight: 600;
  }
  span {
    color: #9c9c9c;
    font-size: 14px;
    font-weight: 400;
  }
}



.radioInputDisabled_hKxLU{
  cursor: initial !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/PaymentSingleOption/PaymentSingleOption.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;;;AAIA;EACE,0BAA0B;AAC5B","sourcesContent":[".paymentSingleOptionContainer {\n  display: flex;\n  gap: 22px;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-start;\n}\n.paymentSingleOptionContainerDisabled{\n  opacity: 0.6;\n}\n\n.paymentSingleOptionIcons {\n  align-items: center;\n  justify-content: flex-start;\n  gap: 4px;\n}\n\n.iconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 28px;\n  background: #fdfdfc;\n  border-radius: 3px;\n  border: 1px solid #e2e2e2;\n}\n\n.paymentSingleOptionText {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  div {\n    color: var(--black-color);\n    font-size: 15px;\n    font-weight: 600;\n  }\n  span {\n    color: #9c9c9c;\n    font-size: 14px;\n    font-weight: 400;\n  }\n}\n\n\n\n.radioInputDisabled{\n  cursor: initial !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentSingleOptionContainer": `paymentSingleOptionContainer_ZlyfD`,
	"paymentSingleOptionContainerDisabled": `paymentSingleOptionContainerDisabled_mO2aG`,
	"paymentSingleOptionIcons": `paymentSingleOptionIcons_W6GNG`,
	"iconWrapper": `iconWrapper_pWSXW`,
	"paymentSingleOptionText": `paymentSingleOptionText_cBNet`,
	"radioInputDisabled": `radioInputDisabled_hKxLU`
};
export default ___CSS_LOADER_EXPORT___;
